import(/* webpackMode: "eager" */ "/vercel/path0/src/app/lend/page.tsx");
